export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-format/src/identity.js
// module id = ../../../../d3-format/src/identity.js
// module chunks = 3